import { render, staticRenderFns } from "./navtop.vue?vue&type=template&id=4b7b0769&scoped=true&"
import script from "./navtop.vue?vue&type=script&lang=js&"
export * from "./navtop.vue?vue&type=script&lang=js&"
import style1 from "./navtop.vue?vue&type=style&index=1&id=4b7b0769&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7b0769",
  null
  
)

export default component.exports